import { render, staticRenderFns } from "./SelectPrescriptionForm.vue?vue&type=template&id=05117df6&scoped=true"
import script from "./SelectPrescriptionForm.vue?vue&type=script&lang=js"
export * from "./SelectPrescriptionForm.vue?vue&type=script&lang=js"
import style0 from "./SelectPrescriptionForm.vue?vue&type=style&index=0&id=05117df6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05117df6",
  null
  
)

export default component.exports